import { render, staticRenderFns } from "./RouteMakingTripDetails.vue?vue&type=template&id=1e3b74a4&scoped=true&"
import script from "./RouteMakingTripDetails.vue?vue&type=script&lang=js&"
export * from "./RouteMakingTripDetails.vue?vue&type=script&lang=js&"
import style0 from "./RouteMakingTripDetails.vue?vue&type=style&index=0&id=1e3b74a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3b74a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
